<template>
  <div style="margin-top: 100px;">
<!--    <AboutBanner v-if="$route.path==='/sub/light-blocks/technical/catalogue'"
                 :content="banners.find(item=>item.id==114).details" :title="banners.find(item=>item.id==114).title" :img="banners.find(item=>item.id==114).photo_file"/>
   --> 
   <div id="catalog-section"></div>
   <about-title :title="$t('catalogues')" page-route="/sub/light-blocks/technical/catalogue"/>
    <v-container>

      <v-row>
        <v-col v-for="(item,i) in catalogues.topics" :key="i" cols="12" sm="12" md="6" xl="6" lg="6">
          <BlockCatalogueItem :item="item"/>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import BlockGalleryItem from "../../subNews/gallery/components/BlockGalleryItem";
import AboutTitle from "../../About/Components/AboutTitle";
import {mapState} from "vuex";
import AboutBanner from "../../About/Components/AboutBanner";
import BlockCatalogueItem from "./BlockCatalogueItem";
export default {
  name: "BlockCatalogue",
  components: {BlockCatalogueItem, AboutBanner, AboutTitle, BlockGalleryItem},
  data() {
    return {
      showImage: '',
      showImageDialog: false,
      galleryItem: [
        {
          id: 1,
          title: 'اردکان',
          file: require('../../../../../../assets/images/news-images/4.jpg'),
          date: '۲۰۱۸-۳-۴',
          views: 2
        },
        {
          id: 2,
          title: 'اردکان',
          file: require('../../../../../../assets/images/news-images/4.jpg'),
          date: '۲۰۱۸-۳-۴',
          views: 2
        },
        {
          id: 3,
          title: 'اردکان',
          file: require('../../../../../../assets/images/news-images/4.jpg'),
          date: '۲۰۱۸-۳-۴',
          views: 2
        },
        {
          id: 4,
          title: 'اردکان',
          file: require('../../../../../../assets/images/news-images/4.jpg'),
          date: '۲۰۱۸-۳-۴',
          views: 2
        },

      ]

    }
  },
  created() {
    if (this.banners==null){
      this.$store.dispatch('lightBlocksManagement/getBlockBanners');
    }
    this.$store.dispatch('lightBlocksManagement/getBlockHomeCatalogue');
  },
  computed:{
    ...mapState({
      catalogues:state => state.lightBlocksManagement.blockHomeCatalogue,
      banners: state => state.lightBlocksManagement.blockBanners,
    })
  }
}
</script>

<style scoped>

</style>